// extracted by mini-css-extract-plugin
export var container = "_2g-0";
export var icon = "_2g-1";